import {useSummary} from 'context/summary';
import {useBrandingTheme} from 'context/brandingTheme';
import {useSplashCoverStore} from 'components/SplashScreen/useSplashCoverStore';

function useIsSessionModalReady() {
  const {isSuccess: isSummaryLoaded = false} = useSummary();
  const {isTemplateInitialized} = useBrandingTheme();
  const isPageUncovered = useSplashCoverStore(state => state.cover === 'none');

  return isTemplateInitialized && isSummaryLoaded && isPageUncovered;
}

export {useIsSessionModalReady};
